import React, { useEffect, useState } from 'react';

type ModalMessageErrorProps = {
    modalMessage: string;
    onClose: () => void;
};

const ModalMessageError: React.FC<ModalMessageErrorProps> = ({ modalMessage, onClose }) => {
    const [progress, setProgress] = useState(0);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        // Crée un intervalle pour augmenter la barre de progression
        const interval = setInterval(() => {
            setProgress(prev => {
                const newProgress = prev + 1;
                if (newProgress >= 100) {
                    clearInterval(interval);
                    setIsExiting(true);
                    setTimeout(onClose, 1500);  // Ferme après 1,5s
                }
                return newProgress;
            });
        }, 30);

        return () => clearInterval(interval);
    }, [onClose]);

    return (
        <div className={`modal ${isExiting ? 'exit' : 'enter'}`}>
            <div className="modal-content">
                <div className="progress-barError" style={{ width: `${progress}%` }} />
                <p>{modalMessage}</p>
            </div>
        </div>
    );
};

export default ModalMessageError;
